<ng-container *ngIf="isBamWeb else isBNCR">
<h1 class="pl-align">{{ 'titlePayWebsiteBAM' | translation | async }}</h1>

<br>
<app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
<br><br>

<div class="methodForm">

  <p>{{ 'referenceNumberFromBAMLine1' | translation | async }}</p>
  <p>{{ 'referenceNumberFromBAMLine2' | translation | async }}</p>
  <br>
  <app-copy-to-clipboard [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>
</div>
</ng-container>

<ng-template #isBNCR>
  <h1 class="pl-align">{{ 'titlePayWebsiteBNCR' | translation | async }}</h1>

  <br>
  <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
  <br><br>

  <div class="methodForm">

    <p>{{ 'referenceNumberFromBNCR' | translation | async }}</p>

    <app-copy-to-clipboard [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>

    <br><br>
    <p class="automatic-approval">
      <b>{{ 'automatic-approval' | translation | async }}</b>
    </p>
  </div>
</ng-template>

